// extracted by mini-css-extract-plugin
export var connectionButton = "_bv-1";
export var connectionButtonFloating = "_bv-2";
export var connectionContainer = "_bv-0";
export var rightPanel = "_bv-6";
export var stepCard = "_bv-3";
export var stepCardSubtitle = "_bv-5";
export var stepCardText = "_bv-4";